'use strict';
angular.module('newRelationModule', [])
    .controller('newRelationCtrl', ['$scope', '$q', '$state', '$modalInstance', 'trsHttpService', 'trsspliceString', 'modalDialog', 'params', 'resourceCenterService', '$stateParams', 'messagePublishService',
        function($scope, $q, $state, $modalInstance, trsHttpService, trsspliceString, modalDialog, params, resourceCenterService, $stateParams, messagePublishService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    item: params.item,
                    modalTitle: params.modalTitle,
                    lanMuIndex: 0, // 左侧选中栏目
                    selectedOriginType: 'app', // 右侧选中渠道
                    mediaType: {
                        'app': 1,
                        'wx': 4,
                        'wb': 5,
                        'szb': 3,
                        'wz': 2,
                    },
                    coloQD: {
                        1: '客户端',
                        2: '网站',
                        3: '数字报',
                        4: '微信',
                        5: '微博',
                    },
                };
                $scope.data = {
                    casDataArea: [], // 地区的级联数组
                    lanMuList: [], // 左侧栏目列表
                    meiTiList: [], // 右侧媒体列表
                    selectedMeiTiObj: [],

                };
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 8,
                    PAGECOUNT: 1,
                    ITEMCOUNT: 0,
                };
                $scope.query = {
                    typeid: 'zyzx',
                    serviceid: 'iwo',
                    modelid: 'subscriptionForQuickSign',
                    keyword: '',
                    acode: '',
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                requestLanMu();
                requestMeiTi();
                if (angular.isDefined($scope.status.item)) {
                    $scope.data.selectedMeiTiObj = angular.copy($scope.status.item.RELMEDIAJSON);
                }
            }

            /**
             * [requestLanMu description] 左侧栏目列表
             * @return {[type]} [description]
             */
            function requestLanMu() {
                if (angular.isDefined($scope.status.item)) {
                    $scope.data.lanMuList = [{
                        CHANNELDESC: $scope.status.item.CHNLDESC,
                        CHANNELID: $scope.status.item.CHANNELID,
                    }];
                } else {
                    var params = {
                        serviceid: 'mlf_appquicksign',
                        methodname: 'queryNotSelectedChannel',
                        SiteId: $stateParams.siteid,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(data) {
                        $scope.data.lanMuList = data;
                    });
                }
            }

            /**
             * [requestMeiTi description] 右侧媒体列表
             * @return {[type]} [description]
             */
            function requestMeiTi() {
                Object.assign($scope.query, {
                    channelName: $scope.status.selectedOriginType,
                    pageNum: $scope.page.CURRPAGE,
                    pageSize: $scope.page.PAGESIZE,
                });
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.query, 'POST').then(function(data) {
                    $scope.data.items = data.content;
                    $scope.page = data.summary_info;
                });
            }

            /**
             * [chooseOrigin description] 渠道选择
             * @param  {[type]} str [description] 当前渠道
             * @return {[type]} [description]
             */
            $scope.chooseOrigin = function(str) {
                $scope.status.selectedOriginType = str;
                $scope.query.pageNum = $scope.page.CURRPAGE = 1;
                requestMeiTi();
            };

            /**
             * [confirm description] 提交
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                if ($scope.data.selectedMeiTiObj.length < 1) {
                    return modalDialog.alertType('请选择关联媒体！', '', 'warning', false);
                }
                if ($scope.data.lanMuList.length === 0) {
                    return modalDialog.alertType('该站点下无栏目，无法保存关联关系！', '', 'warning', false, function() {
                        $modalInstance.close();
                    });
                }
                var params = {
                    serviceid: 'mlf_appquicksign',
                    ChannelId: $scope.data.lanMuList[$scope.status.lanMuIndex].CHANNELID,
                    SelectedMediaInfos: dealMediaInfos(),
                };
                if (angular.isDefined($scope.status.item)) {
                    params.methodname = 'updateQuickSignRelation';
                } else {
                    params.methodname = 'saveQuickSignRelation';
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'POST').then(function(data) {
                    modalDialog.alertType('媒体关联成功', '', 'success', false, function() {
                        $modalInstance.close(data);
                        messagePublishService.publish('refreshList', true);
                    });
                });

            };

            /**
             * [dealMediaInfos description] 关联稿件数据处理
             * @return {[type]} [description]
             */
            function dealMediaInfos() {
                var arr = [];
                $scope.data.selectedMeiTiObj.map((item) => {
                    var obj = {};
                    ['SOURCENAME', 'CHANNEL', 'MEDIA_ID', 'MEDIATYPE', 'HYBASEID'].map((key) => {
                        obj[key] = item[key];
                    });
                    arr.push(obj);
                });
                $scope.data.selectedMeiTiObj = [];
                $scope.data.selectedMeiTiObj = arr;
                return JSON.stringify($scope.data.selectedMeiTiObj);
            }

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [showSelectedArea description] 数据地域信息的级联菜单获取数据
             * @param  {[type]} node [description] 当前节点
             * @return {[type]}      [description]
             */
            $scope.showSelectedArea = function(node) {
                var deffer = $q.defer();
                resourceCenterService.getArea(node).then(function(data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            };

            /**
             * [searchWithKeyword description] 根据条件筛选稿件
             * @param  {[type]} key   [description] 筛选类型
             * @param  {[type]} value [description] 筛选内容
             * @return {[type]}       [description]
             */
            $scope.searchWithKeyword = function(key, value) {
                value = value[0][value[0].length - 1].id;
                $scope.query.acode = value.split('area_')[1];
                $scope.query.pageNum = $scope.page.CURRPAGE = 1;
                requestMeiTi();
            };

            /**
             * [pageChanged description] 换页
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function() {
                requestMeiTi();
            };

            /**
             * [searchOrigin description] 搜索
             *  @param  {[type]} ev [description]
             * @return  {[type]}  [return description]
             */
            $scope.searchOrigin = function(ev) {
                if ((ev && ev.keyCode === 13) || !ev) {
                    $scope.query.pageNum = $scope.page.CURRPAGE = 1;
                    requestMeiTi();
                }
            };

            /**
             * [isChecked description] 判断数据是否选中
             * @param  {[type]}  item [description] 数据
             * @return {Boolean}      [description]
             */
            $scope.isChecked = function(item) {
                return $scope.data.selectedMeiTiObj.some((_item) => {
                    return _item.HYBASEID === item.HYBASEID;
                });
            };

            /**
             * [selectItem description] 选中/取消选中数据
             * @param  {[type]} item [description] 数据
             * @return {[type]}      [description]
             */
            $scope.selectItem = function(item) {
                if ($scope.isChecked(item)) {
                    var index = 0;
                    $scope.data.selectedMeiTiObj.forEach((_item, _index) => {
                        if (_item.HYBASEID === item.HYBASEID) {
                            index = _index;
                        }
                    });
                    $scope.data.selectedMeiTiObj.splice(index, 1);
                } else {
                    $scope.data.selectedMeiTiObj.push(Object.assign(item, { MEDIATYPE: $scope.status.mediaType[$scope.status.selectedOriginType] }));
                }
            };

            /**
             * [selectAll description] 全选
             * @param  {[type]} arr [description] 当前页数据
             * @return {[type]}      [description]
             */
            $scope.selectAll = function(arr) {
                if (arr && arr.length > 0) {
                    var x = 0;
                    arr.map((_item) => {
                        $scope.data.selectedMeiTiObj.map((obj) => {
                            if (_item.HYBASEID === obj.HYBASEID) {
                                x++;
                            }
                        });
                    });
                    arr.map((_item) => {
                        if (x === 0) {
                            $scope.data.selectedMeiTiObj.push(Object.assign(_item, { MEDIATYPE: $scope.status.mediaType[$scope.status.selectedOriginType] }));
                        } else if (x === arr.length) {
                            $scope.data.selectedMeiTiObj.map((obj, index) => {
                                if (_item.HYBASEID === obj.HYBASEID) {
                                    $scope.data.selectedMeiTiObj.splice(index, 1);
                                }
                            });
                        } else {
                            $scope.data.selectedMeiTiObj.map((obj, index) => {
                                if (_item.HYBASEID === obj.HYBASEID) {
                                    $scope.data.selectedMeiTiObj.splice(index, 1);
                                }
                            });
                            $scope.data.selectedMeiTiObj.push(Object.assign(_item, { MEDIATYPE: $scope.status.mediaType[$scope.status.selectedOriginType] }));
                        }
                    });
                }
            };

            /**
             * [isAllChecked description] 判断数据是否全选
             * @param  {[type]}  arr [description] 当前页数据
             * @return {Boolean}      [description]
             */
            $scope.isAllChecked = function(arr) {
                if (arr && arr.length > 0) {
                    var x = 0;
                    arr.forEach((_item) => {
                        $scope.data.selectedMeiTiObj.forEach((obj) => {
                            if (_item.HYBASEID === obj.HYBASEID) {
                                x++;
                            }
                        });
                    });
                    return x === arr.length;
                } else {
                    return false;
                }
            };

            /**
             * [delete description] 删除
             * @param  {[type]}  index [description]
             * @return {Boolean}      [description]
             */
            $scope.delete = function(index) {
                $scope.data.selectedMeiTiObj.splice(index, 1);
            };
        },
    ]);
